import ChooseTagsToFollowModal from './ChooseTagsToFollowModal';
import FollowingHero from './FollowingHero';
import FollowingPageFilterDropdown from './FollowingPageFilterDropdown';
import NewDiscussionNotification from './NewDiscussionNotification';
import NewDiscussionTagNotification from './NewDiscussionTagNotification';
import NewPostNotification from './NewPostNotification';
import SubscriptionModal from './SubscriptionModal';
import SubscriptionOptionItem from './SubscriptionOptionItem';
import SubscriptionStateButton from './SubscriptionStateButton';

export const components = {
  ChooseTagsToFollowModal,
  FollowingPageFilterDropdown,
  NewDiscussionNotification,
  NewDiscussionTagNotification,
  NewPostNotification,
  SubscriptionModal,
  SubscriptionOptionItem,
  SubscriptionStateButton,
  FollowingHero,
};
